const addNoteAtTopOfList = (state, listName, node) => {
  const list = state[listName]

  // don't add it twice if node already in the list
  if (list.nodes.includes(node.id)) {
    return state
  }

  const newList = {
    ...list,
    nodes: [node.id, ...list.nodes],
    edges: [{ node, cursor: 'unknown' }, ...list.edges],
    totalCount: list.totalCount + 1,
  }

  return {
    ...state,
    [listName]: newList,
  }
}

export default function makeAddAsFirstNode(listMatcher, actionType) {
  return function(state, { type, payload: node, metadata }) {
    if (type !== actionType) {
      return state
    }
    return Object.keys(state).reduce((state, listName) => {
      const list = state[listName]
      if (listMatcher(listName, list, node, actionType)) {
        return addNoteAtTopOfList(state, listName, node)
      }
      return state
    }, state)
  }
}
